import React from 'react'
import { useSelector } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import gql from "graphql-tag"

import { SinglePanel } from '@/components/common/panel'
import Files from '@/components/common/file/files'
import { Events } from '@/components/dashboard/pages/module/pages/analytics/dashboard/events'
import Placeholder from '@/components/common/placeholder'
import { useGlobalContext } from '@/components/context'
import { EMPLOYEE_CONTENT_TYPE } from '@/utils/constants'
import { ReduxState } from '@/types/redux'
import { useTitle } from '@/utils/hooks'
import iconStyle from '@sass/common/icon.module.sass'
import { RecordDashboardQuery, useRecordDashboardQuery } from './__gen'
import FormSetDashboard from './form-set-dashboard'
import DetailsSection from './details-section'
import style from './index.module.sass'


gql`
	query recordDashboard($id: ID!) {
		record(
			id: $id
		) {
			id
			name
			position
			archived
			image
			team {
				id
				name
			}
			template {
				id
				position
				formSet {
					id
					dashboard {
						id
						dashboardFields {
							id
							field {
								id
								title
							}
							hideIfBlank
							rank
							answers(recordId: $id)
							form(recordId: $id)
						}
						sections {
							id
							name
							rank
						}
					}
				}
			}
		}
	}
`
type InnerProps = {
	record: NonNullable<RecordDashboardQuery["record"]>
}

const RecordDashboard: React.FC<InnerProps> = ({ record }) => {
	const refreshRecordList = useSelector((state: ReduxState) => state.record.refreshRecordList)
	const globalContext = useGlobalContext()
	useTitle((record.name || 'No Name') + ' - ' + record.team.name)
	return (
		<div>
			<DetailsSection record={record} refreshRecordList={refreshRecordList} />
			
			<div className={style.lineBreak}/>

			{ record.template!.formSet.dashboard &&
				<div>
					<FormSetDashboard dashboard={record.template!.formSet.dashboard} record={record} />
					<div className={style.lineBreak}/>
				</div>
			}

			<div className="analytics-metrics">
				<Events recordId={record.id} />
			</div>

			
			{ globalContext.currentModule.recordFilesEnabled &&
				<>
					<div className={style.lineBreak}/>
					<Files
						contentType={EMPLOYEE_CONTENT_TYPE}
						objectId={record.id}
					/>
				</>
			}
		</div>
	)
}


type Props = RouteComponentProps<{recordId: string}>


const RecordDashboardOuter: React.FC<Props> = (props) => {
	const {currentModule } = useGlobalContext()
	const { data, loading } = useRecordDashboardQuery({ variables: { id: props.match.params.recordId } })
	return (
		<SinglePanel type="wide">
			{ loading
				? <>
					<Placeholder />
					<Placeholder style={{height: 300}}/>
					<Placeholder style={{height: 300}}/>
				</>
			: (!data?.record)
				? (
					<div>
						<h1><span className={iconStyle.warning} />Permission error</h1>
						<p>There was an issue fetching this {currentModule.recordWord}</p>
						<p>If you think this is a bug, please contact support.</p>
					</div>
				)
				: <RecordDashboard {...props} record={data.record} />
			}
		</SinglePanel>
	)
}

export default RecordDashboardOuter